import router from "@/router";
import store from "@/store";

const writelist = ["/login"];

router.beforeEach((to, from, next) => {
  if (!writelist.includes(to.path)) {
    if (sessionStorage.getItem("token")) {
      if (store.state.auth.menus.length <= 0) {
        store.dispatch("auth/FETCH_MENUS");
        next(to);
      } else {
        next();
      }
    } else {
      next({ path: "/login" });
    }
  } else {
    next();
  }
});
